import { NavLink } from 'react-router-dom';
import { FiGrid, FiHome, FiLayers, FiUsers, FiFileText, FiSettings, FiInfo, FiImage, FiMessageSquare, FiShield, FiMail } from 'react-icons/fi';
import { IoIosGitBranch } from 'react-icons/io';
import { AiFillCheckCircle } from 'react-icons/ai';
import { hasRole } from '../../utils/auth';
import './Sidebar.css';

export default function Sidebar() {
  const isSuper = hasRole(['super_admin']);
  return (
    <aside className="asb">
      <div className="asb__brand">
        <span className="asb__logo">RC</span>
        <div>
          <div className="asb__title">Admin Panel</div>
          <div className="asb__sub">RealCity</div>
        </div>
      </div>
      <nav className="asb__nav">
        <NavLink to="/admin" end className="asb__link"><FiGrid /> Dashboard</NavLink>
        <NavLink to="/admin/properties" className="asb__link"><FiHome /> Properties</NavLink>
        <NavLink to="/admin/location" className="asb__link"><FiLayers /> Locations</NavLink>
        <NavLink to="/admin/agents" className="asb__link"><FiUsers /> Agents</NavLink>
        <NavLink to="/admin/amenities" className="asb__link"><AiFillCheckCircle /> Amenities</NavLink>
        <NavLink to="/admin/branches" className="asb__link"><IoIosGitBranch /> Branches</NavLink>
        <NavLink to="/admin/blogs" className="asb__link"><FiFileText /> Blogs</NavLink>
        <NavLink to="/admin/about" className="asb__link"><FiInfo /> About CMS</NavLink>
        <NavLink to="/admin/partners" className="asb__link"><FiImage /> Partners</NavLink>
        <NavLink to="/admin/reviews" className="asb__link"><FiMessageSquare /> Reviews</NavLink>
        <NavLink to="/admin/inquiries" className="asb__link"><FiMail /> Inquiries</NavLink>
        {isSuper ? <NavLink to="/admin/admin-users" className="asb__link"><FiShield /> Admin Users</NavLink> : null}
        <NavLink to="/admin/settings" className="asb__link"><FiSettings /> Settings</NavLink>
      </nav>
    </aside>
  );
}
